import React, { Component } from 'react'
import $ from 'jquery'

import IntlMessage from '../../common/intl/intl_message.jsx'
import app from '../../../app.jsx'

class PageDemoImport extends Component {
  componentDidMount () {
    this._loadDemoData()
  }

  render () {
    return (
      <div className='page-emailconfimation demoimport'>
        <div className='container'>
          <img alt='logo' className='logo' src='/images/common/rodeo_logo.svg' />
          <div className='content typo'>
            <h1 className='title'>
              <IntlMessage ident='common.demo.loaderTitle' />
            </h1>
            <div className='content'>
              <p>
                <IntlMessage ident='common.demo.loaderMessage' />
              </p>
              <img alt='' class='focus-image' src='/images/common/focus.png' />
            </div>
          </div>
        </div>
      </div>
    )
  }

  _loadDemoData () {
    const country = $('#root').data('country') || 'NL'
    const demoTeamParams = {
      query: {
        $client: { country }
      }
    }
    app.service('/api/team/demo').timeout = 30000

    return app
      .service('/api/team/demo')
      .create({}, demoTeamParams)
      .then(({ email, password, demoCode }) => {
        return app
          .service('/api/team')
          .find({
            query: {
              'demoInfo.code': demoCode
            },
            $limit: 1
          })
          .then(demoTeamRes => {
            if (!demoTeamRes || (demoTeamRes.data && demoTeamRes.data.length === 0)) {
              throw new Error('Could not find created demo team')
            }

            return app.authentication.login({
              email,
              password
            })
          })
          .then(() => app.redirect('/'))
      }).catch(err => {
        app.debug('Error in creating demo environment', err)
        // If we get an error when creating a demo and it is a "demo user not found"
        // error then we try to reload again because the user could have been automatically deleted
        if (err.name === 'NotFound') {
          return app.authentication.logout('/')
        }

        return app.authentication.logout()
      })
  }
}

export default PageDemoImport
